export const USER_ROLES = {
  TESTER: 'tester',
} as const;
